import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Loader from "../components/Loader";
import LoginService from "../services/LoginService";

const LoginForm = ({ setIsLoggedIn }) => {
  const loginService = new LoginService();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    Email: "",
    Password: ""
  });

  const [state, setState] = useState({
    loading: false
  });

  const [showPassword, setShowPassword] = useState(false);

  function changeHandler(event) {
    setFormData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value
    }));
  }

  async function submitHandler(event) {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    event.preventDefault();
    try {
      const obj = {
        Email: formData.Email,
        Password: formData.Password
      };
      loginService.CheckUser(obj).then((response) => {
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
        if (response.responseCode == "200") {
          sessionStorage.setItem("token", response.responseData.token);
          sessionStorage.setItem(
            "refreshToken",
            response.responseData.refreshToken
          );
          sessionStorage.setItem("userId", response.responseData.userId);
          sessionStorage.setItem("userName", response.responseData.username);
          sessionStorage.setItem("email", response.responseData.email);
          sessionStorage.setItem("userType", response.responseData.userType);
          sessionStorage.setItem(
            "wareHouseId",
            response.responseData.wareHouseId
          );
          setIsLoggedIn(true);
          navigate("/dashboard");
        } else if (response.responseCode == "400") {
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
          toast.error(response.responseMessage);
        }
      });
    } catch (error) {
      setState((prevData) => ({
        ...prevData,
        loading: false
      }));
      console.error("Login failed:", error);
      toast.error("Login failed. Please check your credentials.");
    }
  }

  return (
    <>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="login-page loginon">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1">
                <div className="bg-white shadow rounded">
                  <div className="row">
                    <div className="col-md-7 pe-0">
                      <div className="form-left pt-3 px-5">
                        <form onSubmit={submitHandler}>
                          <h1 className="mb-3 sticker">LOGIN</h1>
                          <h4 className="mb-3 retailer">
                            Only For Authorized Users
                          </h4>
                          <div className="col-12">
                            <label>
                              Email Address
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                required
                                type="Email"
                                value={formData.Email}
                                onChange={changeHandler}
                                placeholder="Enter email address"
                                name="Email"
                                className="bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full p-[12px]"
                              />
                            </div>
                          </div>
                          <div className="col-12 mt-2">
                            <label>
                              Password<span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                required
                                type={showPassword ? "text" : "Password"}
                                value={formData.Password}
                                onChange={changeHandler}
                                placeholder="Enter Password"
                                name="Password"
                                className="bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full p-[12px]"
                              />
                              <span
                                className="absolute right-3 top-[10px] cursor-pointer"
                                onClick={() => setShowPassword((prev) => !prev)}
                              >
                                {showPassword ? (
                                  <AiOutlineEyeInvisible
                                    fontSize={24}
                                    fill="#AFB2BF"
                                  />
                                ) : (
                                  <AiOutlineEye fontSize={24} fill="#AFB2BF" />
                                )}
                              </span>
                            </div>
                          </div>

                          <div className="col-12">
                            <button className="btn-block rounded-[8px] font-medium text-richblack-900 px-[12px] py-[8px] mt-6">
                              SIGN IN
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="col-md-5 ps-0 d-md-block">
                      <div className="form-right text-white text-center ">
                        <img
                          src="img/logine.jpg"
                          className="img-fluid"
                          alt="login-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginForm;
